// extracted by mini-css-extract-plugin
export default {"container":"CampaignFormContainer_container__2tTuM","switchContainer":"CampaignFormContainer_switchContainer__p7zcM"};